import type { AppNotification, NotificationPreferences } from "../../domain/app-types.ts";

export function freshUnreadNotifications(items: AppNotification[], notified: Set<string>): AppNotification[] {
  return items.filter(item => !item.read && !notified.has(item.id));
}

export interface NotificationRefreshCapabilities {
  hasUser(): boolean;
  request(path: string, init?: RequestInit): Promise<Response>;
  setNotifications(items: AppNotification[]): void;
  notified(): Set<string>;
  permission(): NotificationPermission | "unsupported";
  notify(title: string, options: NotificationOptions): void;
  shellPresent(): boolean;
  render(): Promise<void>;
}

export function createNotificationRefreshController(capabilities: NotificationRefreshCapabilities) {
  return async (render = true): Promise<void> => {
    if (!capabilities.hasUser()) return;
    const response = await capabilities.request("/api/v1/notifications", { credentials: "include" }).catch(() => null);
    if (!response?.ok) return;
    const next = await response.json() as AppNotification[]; const fresh = freshUnreadNotifications(next, capabilities.notified()); capabilities.setNotifications(next);
    fresh.forEach(item => capabilities.notified().add(item.id));
    if (fresh.length && capabilities.permission() === "granted") {
      const rootIds = [...new Set(fresh.map(item => item.root_id).filter((id): id is string => Boolean(id)))];
      const preferences = new Map(await Promise.all(rootIds.map(async rootId => {
        const value = await capabilities.request(`/api/v1/roots/${rootId}/notification-preferences`, { credentials: "include" }).then(result => result.ok ? result.json() : null).catch(() => null) as NotificationPreferences | null;
        return [rootId, value] as const;
      })));
      fresh.filter(item => item.root_id && preferences.get(item.root_id)?.browser_notifications).forEach(item => capabilities.notify("WeirDo", { body: item.message, tag: item.id }));
    }
    if (render && capabilities.shellPresent()) await capabilities.render();
  };
}
